import React, {Component} from 'react';
import HeaderSectionComponent from '../HeaderSectionComponent/HeaderSectionComponent';
import TandCComponent from '../TandCComponent/TandCComponent';
import CalloutCardComponent from '../CalloutCardComponent/CalloutCardComponent';
import ChangePasswordComponent from '../ChangePasswordComponent/ChangePasswordComponent';
import {EdapProvider} from '@homeaway/react-event-tracking';

class ChangePasswordPageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            errorTitle: ''
        };
    }

    clearAlert = () => {
        this.setState({error: '', errorTitle: ''});
    };

    handleError = (error) => {
        this.setState({error});
    };

    render() {
        const {lingua, multiUserEnabled, siteName} = this.props;
        const {error, errorTitle} = this.state;
        let options = {siteName};
        let title = this.props.isLegacy === true ? lingua.read('lex.header.legacy') : lingua.read('lex.header.password', options);
        let subtitle = this.props.isLegacy === true ? lingua.read('lex.legacy.subheader') : null;
        let cardContent = (
            <ChangePasswordComponent
                handleError={this.handleError}
                {...this.props}
            />
        );

        return (
            <EdapProvider>
                <div className="ChangePasswordPageComponent border-border-color">
                    <HeaderSectionComponent title={title} subtitle={subtitle}/>
                    <CalloutCardComponent content = {cardContent} error={error} errorTitle={errorTitle} clearAlert={this.clearAlert}/>
                    <TandCComponent lingua={lingua} multiUserEnabled={multiUserEnabled}/>
                </div>
            </EdapProvider>
        );
    }
}

export default ChangePasswordPageComponent;
